import { render, staticRenderFns } from "./CadastroWidget.vue?vue&type=template&id=3e82558b&"
import script from "./CadastroWidget.vue?vue&type=script&lang=js&"
export * from "./CadastroWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports